import { useQuery } from "@tanstack/react-query";
import { WhatsAppConfigResponseDto } from "../../../models/organization/dto/organization.dto";
import { useApiClient } from "../../../apiClient";

export const GET_WHATSAPP_CONFIG_QUERY_KEY = (organizationId: string) => ['organization', organizationId, 'whatsappConfig'];

export const useGetWhatsAppConfig = (organizationId: string) => {
    const apiClient = useApiClient();

    return useQuery<WhatsAppConfigResponseDto>({
        queryKey: GET_WHATSAPP_CONFIG_QUERY_KEY(organizationId),
        queryFn: () =>
            apiClient.fetchApi<WhatsAppConfigResponseDto, {}>({
                method: 'GET',
                endpoint: `organizations/${organizationId}/whatsapp-config`,
            }),
        enabled: !!organizationId,
    });
};
